module.exports = __webpack_public_path__ + "static/media/cambridge3.371cea13.png";